export const Feature = [
  {
    key: "shinsuishin",
    label: "洪水浸水想定区域\n(想定最大規模)",
    urls: [
      "https://s3.ap-northeast-1.amazonaws.com/ctie.tamura.web/static/tile/shinsuiHM/{z}/{x}/{y}.png"
    ],
    usageGuide: [
      {
        title: "洪水浸水想定区域\n想定浸水深（ｍ）",
        colors: [
          { color: "rgb(220, 122, 220)", value: "20.0~" },
          { color: "rgb(242, 133, 201)", value: "10.0~20.0" },
          { color: "rgb(255, 145, 145)", value: "5.0~10.0" },
          { color: "rgb(255, 183, 183)", value: "3.0~5.0" },
          { color: "rgb(255, 216, 192)", value: "0.5~3.0" },
          { color: "rgb(247, 245, 169)", value: "~0.5" }
        ]
      }
    ],
    isShow: true
  },
  {
    key: "kaokutoukai_hanran_kagan",
    label: "家屋倒壊等氾濫想定区域\n(氾濫流・河岸侵食)",
    urls: [
      "https://s3.ap-northeast-1.amazonaws.com/ctie.tamura.web/static/tile/toukaiHM/{z}/{x}/{y}.png"
    ],
    usageGuide: [
      {
        title: "家屋倒壊等氾濫想定区域\n(氾濫流・河岸侵食)",
        images: [
          {
            url: require("../assets/images/png/kaokutoukai_hanran.png"),
            value: "氾濫流"
          },
          {
            url: require("../assets/images/png/kaokutoukai_kagan.png"),
            value: "河岸侵食"
          }
        ]
      }
    ],
    isShow: true
  },
  {
    key: "shinsui_tameike",
    label: "浸水想定区域\n(ため池)",
    urls: [
      "https://s3.ap-northeast-1.amazonaws.com/ctie.tamura.web/static/tile/tameikeHM/{z}/{x}/{y}.png"
    ],
    usageGuide: [],
    isShow: true
  },
  {
    key: "dosyasaigai_keikaikuiki",
    label: "土砂災害警戒区域",
    urls: [
      "https://disaportaldata.gsi.go.jp/raster/05_jisuberikeikaikuiki/{z}/{x}/{y}.png",
      "https://disaportaldata.gsi.go.jp/raster/05_dosekiryukeikaikuiki/{z}/{x}/{y}.png",
      "https://disaportaldata.gsi.go.jp/raster/05_kyukeishakeikaikuiki/{z}/{x}/{y}.png"
    ],
    usageGuide: [
      {
        title: "特別警戒区域",
        colors: [
          { color: "rgb(193, 76, 98)", value: "土石流" },
          { color: "rgb(252, 104, 77)", value: "急傾斜地の崩壊" },
          { color: "rgb(203, 76, 147)", value: "地滑り" }
        ]
      },
      {
        title: "警戒区域",
        colors: [
          { color: "rgb(238, 216, 118)", value: "土石流" },
          { color: "rgb(255, 237, 90)", value: "急傾斜地の崩壊" },
          { color: "rgb(255, 183, 84)", value: "地滑り" }
        ]
      }
    ],
    isShow: true
  },
  {
    key: "shelter",
    label: "避難所",
    urls: [],
    usageGuide: [],
    isShow: true
  },
  {
    key: "meeting",
    label: "集会所",
    urls: [],
    usageGuide: [],
    isShow: true
  }
];
